import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { environment } from "environment";
import { Injectable } from "@angular/core";

export const EmailSettingsGuard: CanActivateFn = (
  ): Promise<boolean> | boolean | Observable<boolean> => {
    if (environment.SHOW_EMAIL_SETTINGS === 'true') {
      return true;
    }
    window.location.href = window.location.origin + '/404';
    return false;
  }

export const LargeDownloadsGuard: CanActivateFn = (
  ): Promise<boolean> | boolean | Observable<boolean> => {
    if (environment.SHOW_LARGEDOWNLOAD === 'true') {
      return true;
    }
    window.location.href = window.location.origin + '/404';
    return false;
  }

  @Injectable()
  export class FeedsGuard {
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean | Observable<boolean> {
      if (environment.SHOW_FEEDS === "true")  {
          return true;
      }
      window.location.href = window.location.origin + '/404';
      return false;
    }
  }

@Injectable()
export class NavigatedFor {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean | Observable<boolean> {
    if(route.data && (route.data.navigatedFor === 'details' || route.data.navigatedFor === 'access')) {
      window.location.href = window.location.origin + '/profile/' + route.data.navigatedFor + '?isShowContractData=true';
      return false;
    }
    return true;
  }
}
